<template>
  <div id ="container">
  <v-list>
    <v-list-item
      v-for="(item, index) in itemsToDisplay"
      :key="index"
      @click="itemClick(item)"
    >
      <v-list-item-icon class="return-icon" v-if="item.isParent">
        <v-icon color="white"> $vuetify.icons.linkArrow </v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title class="link-list-item-text" v-text="item.title" />
      </v-list-item-content>
      <v-list-item-icon
        v-if="
         !item.isParent && item.children != null && item.children.length > 0
        "
      >
        <v-icon color="white"> $vuetify.icons.linkArrow </v-icon>
      </v-list-item-icon>
    </v-list-item>

    <v-list-item target="_blank" href="https://askod.online">
      <v-list-item-title class="link-list-item-text text-center">
        {{ $t('linkList.askodOnline')}}
      </v-list-item-title>
    </v-list-item>

    <v-list-item :to="{ name: 'page', params: { urlKey: 'anketa-sed' } }">
      <v-list-item-content>
        <v-list-item-title class="link-list-item-text text-center">
              {{ $t('linkList.orderCalculation')}}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-spacer></v-spacer>
  </v-list>
  </div>
</template>
<script>
export default {
  name: 'LinkList',
  props: {
    items: {
      required: true,
      default: () => []
    }
  },
  data: () => ({
    itemsToDisplay: []
  }),
  methods: {
    itemClick(item) {
      if (item.isParent) {
        this.itemsToDisplay = this.allItems
      }

      if (!item.isParent && item.children != null && item.children.length > 0) {
        this.itemsToDisplay = [{ ...item, isParent: true }, ...item.children]
      }

      if (item.children.length === 0) {
        var url = `/page/${item.pageId}`
        this.$router.push(url)
        this.itemsToDisplay = this.allItems
        this.$emit('close')
      }
    }
  },
  created() {
    this.itemsToDisplay = this.allItems
  },
  computed: {
    allItems: function () {
      return this.items
    }
  }
}
</script>

<style lang="scss" scoped>
.return-icon {
  transform: rotate(180deg);
}
.link-list-item-text {
  font-size: 2rem;
  color: white;
}

</style>
